import { ScreenProps } from '@components-common/types';
import { ConfigElement } from '@components-fabric';
import { UnderDevelopmentPage } from '@components-common/layouts';

export const mapUnderDevScreen = (config:ConfigElement, context: ScreenProps) => {
  const result = {
    type: "under_development",
    view: {
      Component: UnderDevelopmentPage
    }
  };
  return result;
}
